import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { registerLocale } from 'react-datepicker';
import de from 'date-fns/locale/de';

registerLocale('de', de);

export const Datepicker = ({ label, id, requested, unit, value, setValue }) => {
    const handelChanges = (date) => {
        const unixTimestamp = date.getTime();

        const newValue = {
            dateObject: date,
            date: date.toLocaleDateString('de-DE', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
            }),
            unixTimeStamp: unixTimestamp,
        };
        setValue(newValue);
    };

    return (
        <div className={'flex flex-col justify-center max-h-[400px] max-w-[500px] w-full'}>
            <h4 className="font-semibold text-sm mb-2 text-gray-900">
                {label}<span className='ml-1 text-sm font-light text-indigo-900 text-xs'>{requested ? '(Pflichtfeld)' : ''}</span>
            </h4>
            <label
                htmlFor={id}
                className="sr-only">
                {label}
            </label>
            <DatePicker
                placeholder={label}
                name={id}
                required={requested}
                className={'w-full text-sm'}
                dateFormat='dd.MM.yyyy' // Set the desired date format
                locale='de' // Set the locale to German
                placeholderText='TT.MM.JJJJ' // Placeholder in German format
                onChange={(date) => handelChanges(date)}
                selected={value.dateObject ? value.dateObject : ''}
            />
        </div>
    );
};
